import React, { useState, useCallback, useEffect } from "react";
import { MasterDetailLayout, ConfirmDialog, Breadcrumb } from "../../../components/Common";
import BankAccountSidebar from "./components/BankAccountSidebar";
import BankAccountEditor from "./components/BankAccountEditor";
import { useBankAccounts } from "./hooks/useBankAccounts";
import { bankAccountDefaults } from "../../../models/bankAccount";

/**
 * BankAccounts Page (Gestão de Contas Bancárias e Caixas)
 * Layout Master-Detail seguindo o padrão premium do NeoApp.
 */
const BankAccountsPage = () => {
    const {
        accounts,
        loading,
        isSaving,
        actions
    } = useBankAccounts();

    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isDirty, setIsDirty] = useState(false);



    // Seleção inicial automática
    useEffect(() => {
        if (!selectedAccount && accounts.length > 0 && !loading) {
            setSelectedAccount(accounts[0]);
        }
    }, [accounts, loading, selectedAccount]);

    const handleSelectAccount = useCallback(async (account) => {
        if (selectedAccount?.id === account.id) return;

        if (isDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Você tem alterações de conta bancária não salvas. Deseja descartá-las?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }

        setSelectedAccount(account);
        setIsDirty(false);
    }, [selectedAccount, isDirty]);

    const handleCreateNew = useCallback(async () => {
        if (isDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Deseja descartar as mudanças atuais e criar uma nova conta?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }
        setSelectedAccount({ ...bankAccountDefaults });
        setIsDirty(false);
    }, [isDirty]);

    const handleSave = useCallback(async (data) => {
        const success = await actions.saveAccount(data);
        if (success) {
            setIsDirty(false);
        }
    }, [actions]);

    const handleDelete = useCallback(async (id) => {
        const success = await actions.deleteAccount(id);
        if (success) {
            setSelectedAccount(null);
            setIsDirty(false);
        }
    }, [actions]);

    const handleMarkDirty = useCallback((dirty) => setIsDirty(dirty), []);

    // PageLoader logic removido para carregamento nativo do sidebar/detalhe

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Contas e Caixas" />
            </div>
            
            <div className="border-top mb-3"></div>
            
            <MasterDetailLayout
                    master={
                        <BankAccountSidebar
                            accounts={accounts}
                            activeId={selectedAccount?.id}
                            onSelect={handleSelectAccount}
                            onCreateNew={handleCreateNew}
                            loading={loading}
                        />
                    }
                    detail={
                        <BankAccountEditor
                            account={selectedAccount}
                            onSave={handleSave}
                            onDelete={handleDelete}
                            isSaving={isSaving}
                            onChange={handleMarkDirty}
                        />
                    }
                />
        </React.Fragment>
    );
};

export default BankAccountsPage;
